export default "__VITE_ASSET__1vS5X_b8__"